import React, { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import './App.css';
import PageNavigation from './navigation/PageNavigation';
import Navbar from './navigation/Navbar';
import ScrollTop from './components/ScrollTop';
import BoookingData from './Booking/BoookingData';
import LiveChat from './Livechat/LiveChat';
import Location from './components/Location';

function App() {
	const [location, setLocation] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const storedLocation = localStorage.getItem('location');
		if (storedLocation) {
			setLocation(storedLocation);
		}
		setLoading(false); // done checking
	}, []);

	const handleLocationChange = (selectedLocation) => {
		setLocation(selectedLocation);
		localStorage.setItem('location', selectedLocation);
	};

	if (loading) {
		return <div>Loading...</div>; // or spinner
	}

	if (!location) {
		return <Location onLocationSelect={handleLocationChange} />;
	}

	return (
		<BrowserRouter>
			<ScrollTop />
			<Navbar />
			<PageNavigation />
			<LiveChat />
			<BoookingData />
		</BrowserRouter>
	);
}

export default App;
